<script>
  'use strict'

  import { _gridGap } from '../store/store';

  _gridGap.subscribe(data => {
    document.documentElement.style.setProperty('--grid-gap', `${data}px`);
  })
</script>

<div>
  <label for="gridGap">Grid Gap</label>
  <input type="number" name="gridGap" id="gridGap" min="0" bind:value={$_gridGap} tabindex=3>
</div>
